exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".customBlockList {\r\n  background: #fff;\r\n  border: 1px solid #ccc;\r\n  box-shadow: 0 2px 4px #ccc;\r\n  position: absolute;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-wrap: wrap;\r\n  padding: 0;\r\n  margin: 0;\r\n  max-height: 500px;\r\n  z-index: 10;\r\n}\r\n.customBlockList .customBlock {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0.5rem 1.5rem;\r\n  cursor: pointer;\r\n}\r\n.customBlockList .customBlock:hover {\r\n  background: #efefef;\r\n}\r\n.customOptionList {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n}", ""]);

// exports
